var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMail = function SvgMail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 46,
    viewBox: "0 0 56 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7.99986C0.5 3.8695 3.86901 0.500488 7.99937 0.500488H47.9994C52.1297 0.500488 55.4987 3.8695 55.4987 7.99986V37.9999C55.4987 42.1302 52.1297 45.4992 47.9994 45.4992H7.99937C3.86901 45.4992 0.5 42.1302 0.5 37.9999V7.99986ZM5.76502 6.88494L27.9994 22.449L50.2337 6.88494C49.8203 6.06691 48.9697 5.49924 47.9994 5.49924H7.99937C7.02904 5.49924 6.17848 6.06691 5.76502 6.88494ZM50.5 12.8003L29.4327 27.5474C28.5721 28.1498 27.4267 28.1498 26.5661 27.5474L5.49875 12.8003V37.9999C5.49875 39.3695 6.62974 40.5005 7.99937 40.5005H47.9994C49.369 40.5005 50.5 39.3695 50.5 37.9999V12.8003Z",
    fill: "#2A60EA"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mail.f246fbc37231ea43954fe530ad52e820.svg";